import SafetyReportsIcon from "../../../../assets/icons/safety-reports-icon";
import RiskReviewIcon from "../../../../assets/icons/risk-review-icon";
import UserActivityIcon from "../../../../assets/icons/user-activity-icon";
import PastReportsIcon from "../../../../assets/icons/past-reports-icon";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PersonRemoveIcon from "@mui/icons-material/PersonRemove";
import ScheduleIcon from "@mui/icons-material/Schedule";
import React from "react";
import {CustomerTypes} from "../../../../types";

const iconColor = "#206FA5"
// Match the custom brand glyphs' footprint so MUI icons sit at the same size.
const muiIconSx = { color: iconColor, fontSize: 30 };

export const getReportsCollection = (customerSettings : CustomerTypes.Settings) => {

    const {isSafetyReportEnabled, isActivityReportEnabled, showRiskAssessment, showGroupsTeamsDashboard} = customerSettings || {};

    return [
        // 1. Safety Report on top. When Intake Risk Assessment is on it replaces
        // this tile entirely and lives at /risk-assessment in the main nav.
        ...(isSafetyReportEnabled && !showRiskAssessment ? [{
            groupTitle: 'Risk & Safety',
            reports: [{
                icon: <SafetyReportsIcon stroke={iconColor} />,
                title: 'Safety Report',
                description: 'Get insights into the safety data of a specific location.',
                navigateUrl: '/reports/safety-report'
            }]
        }] : []),
        // 2. Groups & Teams Activity + Dashboard
        ...((isActivityReportEnabled || showGroupsTeamsDashboard) ? [{
            groupTitle: 'User Activity',
            reports: [
                ...(isActivityReportEnabled ? [{
                    icon: <UserActivityIcon stroke={iconColor} />,
                    title: 'Groups & Teams Activity',
                    description: 'Activity trends across Groups and Teams over time.',
                    navigateUrl: '/reports/user-activity'
                }] : []),
                ...(showGroupsTeamsDashboard ? [{
                    icon: <DashboardIcon sx={muiIconSx} />,
                    title: 'Groups & Teams Dashboard',
                    description: 'Drill into groups, teams, and individual user activity.',
                    navigateUrl: '/reports/groups-teams-activity'
                }] : [])
            ]
        }] : []),
        // 3. Visit Risk Review
        {
            groupTitle: 'Risk Review',
            reports: [{
                icon: <RiskReviewIcon stroke={iconColor} />,
                title: 'Visit Risk Review',
                description: 'Analyze historical data for informed risk decisions.',
                navigateUrl: '/reports/visit-risk-review'
            }]
        },
        // 4. Field Safety Reports
        {
            groupTitle: 'Field Safety Reports',
            reports: [{
                icon: <PastReportsIcon stroke={iconColor} />,
                title: 'Field Safety Reports',
                description: 'Reports filed in the field that warn nearby teammates on mobile.',
                navigateUrl: '/reports/field-safety-reports'
            }]
        },
        // 5. Deprovisioned Users
        {
            groupTitle: 'Deprovisioning',
            reports: [{
                icon: <PersonRemoveIcon sx={muiIconSx} />,
                title: 'Deprovisioned Users',
                description: 'Users removed from your subscription, with their group, team, tags, and devices at removal time.',
                navigateUrl: '/reports/deprovisioned-users'
            }]
        },
        // 6. Scheduled Reports last
        {
            groupTitle: 'Scheduled Reports',
            reports: [{
                icon: <ScheduleIcon sx={muiIconSx} />,
                title: 'Scheduled Reports',
                description: 'Automate reports on a cadence and email them to recipients you choose.',
                navigateUrl: '/reports/scheduled-reports'
            }]
        },
    ];
}
